export const blockIconsNavigationExpandCircleDown = (
	<span className='material-symbols-outlined'>expand_circle_down</span>
);
